document.addEventListener('DOMContentLoaded', function () {
    var modal = document.getElementById('myModal');
    var btn = document.getElementById('myBtn');
    var span = document.getElementsByClassName('close')[0];
        const successMessage = document.getElementById('success-message');
    const enqueryForm = document.getElementById('enquery-form');

    btn.onclick = function () {
      modal.style.display = 'block';
        enqueryForm.style.display = 'block';
        successMessage.style.display = 'none';
    };


    span.onclick = function () {
      modal.style.display = 'none';
      window.history.replaceState(null, '', window.location.pathname);
    };

    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = 'none';
      }
    };
  });



   document.getElementById('product-contact-btn').addEventListener('click', function (e) {
    e.preventDefault();

    const contactName = document.getElementById('contact-name');
    const contactEmail = document.getElementById('contact-email');
    const contactMessage = document.getElementById('contact-message');
        const product_contact_btn = document.getElementsByClassName('contact-button');


    let valid = true;
    // Name input validation
    if (!contactName.value.trim()) {
      contactName.classList.add('error');
      valid = false;
    } else {
      contactName.classList.remove('error');
    }

    // Email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailValue = contactEmail.value.trim();
    if (!emailValue || !emailPattern.test(emailValue)) {
      contactEmail.classList.add('error');
      valid = false;
    } else {
      contactEmail.classList.remove('error');
    }
    // Message input validation
    if (!contactMessage.value.trim()) {
      contactMessage.classList.add('error');
      valid = false;
    } else {
      contactMessage.classList.remove('error');
    }

    if (valid) {
      e.target.closest('form').submit();
        const btn = document.getElementById('product-contact-btn');
        btn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0907/9947/2986/files/21-18-05-265_512.webp?v=1751274523" alt="Loading..." style="width: 30px;">`;
        btn.style.setProperty('padding', '4px', 'important');


      
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
     const modal = document.getElementById('myModal');
    const successMessage = document.getElementById('success-message');
    const enqueryForm = document.getElementById('enquery-form');

    const params = new URLSearchParams(window.location.search);
    const hash = window.location.hash;

    if (params.get('contact_posted') === 'true' && hash === '#contact_form') {
      if (modal && successMessage) {
        modal.style.display = 'block';
        enqueryForm.style.display = 'none';
        successMessage.style.display = 'block';
      }
     

    }
  });